import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get_freelancer_active_orders, get_order_showcase } from '../../Apis/index';

export const ProjectsOrders = createAsyncThunk('ProjectsOrders', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await get_freelancer_active_orders(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetShowcaseOrder = createAsyncThunk('GetShowcaseOrder', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await get_order_showcase(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


const freelancerOrderSlice = createSlice({
    name: 'freeOrder',
    initialState: {
        error: null,
        success: false,
        data: [],
        showcase: []
   
    },
    reducers: {
        clearFreeOrderStatus: state => {
            state.success = false;
            state.error = null;
        },

        clearTabdata: state => {
            state.showcase = [];
            state.data = [];
        }
    },
    extraReducers: builder => {
        builder
            .addCase(ProjectsOrders.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(ProjectsOrders.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(ProjectsOrders.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetShowcaseOrder.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetShowcaseOrder.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.showcase = action.payload.data.data;
            })
            .addCase(GetShowcaseOrder.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearFreeOrderStatus, clearTabdata } = freelancerOrderSlice.actions;
export default freelancerOrderSlice.reducer;

